import { Component, Input, NgZone, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CSEService } from '../../services/cse.service';
import {
    SearchCarrierIncident
} from '../../models/models';

@Component({
    selector: 'carrier-incident-grid',
    templateUrl: './carrier-incident-grid.component.html',
    standalone: false
})
export class CarrierIncidentGrid implements OnChanges {
    @Input() carrierID: number = 0;

    @ViewChild(GridComponent, { static: false }) public incidentGrid!: GridComponent;

    public isLoading: boolean = false;
    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public carrierIncidentID: number = 0;
    public incidentList: SearchCarrierIncident[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'carrierIncidentID' }] };

    constructor(private cseService: CSEService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getCarrierIncidents();
    }

    private getCarrierIncidents() {
        this.isLoading = true;
        this.cseService.getSearchCarrierIncidentsByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.incidentList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.incidentList = orderBy(this.incidentList, this.gridState.sort);

        this.gridData = process(this.incidentList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.incidentGrid == null) return;
            this.incidentGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(carrierIncidentID: number) {
        this.carrierIncidentID = carrierIncidentID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public delete(carrierIncidentID: number) {
        var idx = this.incidentList.findIndex(c => c.carrierIncidentID == carrierIncidentID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to delete this incident?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.cseService.deleteCarrierIncident(carrierIncidentID).subscribe(result => {
                this.getCarrierIncidents();
            });
        });
    }

    public addNew() {
        this.carrierIncidentID = 0;
        this.isEdit = false;
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
        this.getCarrierIncidents();
    }
}
